import { Tag } from "bbcode-to-react";
import * as React from "react";
class SizeTag extends Tag {
    toHTML() {
        const size = this.params.size;
        if (isNaN(size)) {
            return [this.getContent()];
        }
        return [
            `<span style="font-size:${this.calc(size)}">`,
            this.getContent(),
            "</span>",
        ];
    }
    toReact() {
        const size = this.params.size;
        if (isNaN(size)) {
            return this.getComponents();
        }
        return [
            React.createElement("span", { style: { fontSize: this.calc(size) } }, this.getComponents()),
        ];
    }
    calc(sizeFactor) {
        return `${1 + sizeFactor * 0.1}rem`;
    }
}
export default SizeTag;
